import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  // Lazily read baseUrl to avoid early APP_INITIALIZER timing issues
  private get baseUrl(): string {
    return AppConfig.settings.baseUrl;
  }
  private _reqHeader = new HttpHeaders({ 'Accept': 'application/json', 'Content-Type': 'application/json' });

  constructor(
    private _http: HttpClient,
  ) {}

  getSchedule() {
    return this._http.get(this.baseUrl + '/api/Schedule/GetSchedule', { headers: this._reqHeader });
  }

  getTemporarySchedule() {
    return this._http.get(this.baseUrl + '/api/Schedule/GetTemporarySchedule', { headers: this._reqHeader });
  }

  updateSchedule(schedule: unknown) {
    return this._http.put(this.baseUrl + '/api/Schedule/UpdateSchedule', schedule, { headers: this._reqHeader });
  }

  commitTemporarySchedule() {
    return this._http.post(this.baseUrl + '/api/Schedule/CommitTemporarySchedule', null, { headers: this._reqHeader });
  }

  setDailyScheduledEventBackwardOneDay(dailyScheduledEventAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/SetDailyScheduledEventBackwardOneDay/' + dailyScheduledEventAsString, { headers: this._reqHeader });
  }

  setDailyScheduledEventForwardOneDay(dailyScheduledEventAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/SetDailyScheduledEventForwardOneDay/' + dailyScheduledEventAsString, { headers: this._reqHeader });
  }

  setWeeklyScheduledEventBackwardOneWeek(weeklyScheduledEventAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/SetWeeklyScheduledEventBackwardOneWeek/' + weeklyScheduledEventAsString, { headers: this._reqHeader });
  }

  setWeeklyScheduledEventForwardOneWeek(weeklyScheduledEventAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/SetWeeklyScheduledEventForwardOneWeek/' + weeklyScheduledEventAsString, { headers: this._reqHeader });
  }

  setYearlyScheduledEventBackwardOneYear(yearlyScheduledEventAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/SetYearlyScheduledEventBackwardOneYear/' + yearlyScheduledEventAsString, { headers: this._reqHeader });
  }

  setYearlyScheduledEventForwardOneYear(yearlyScheduledEventAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/SetYearlyScheduledEventForwardOneYear/' + yearlyScheduledEventAsString, { headers: this._reqHeader });
  }

  isScheduleWindowOpen(scheduleWindowAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/IsScheduleWindowOpen/' + scheduleWindowAsString, { headers: this._reqHeader });
  }

  isTemporaryScheduleWindowOpen(scheduleWindowAsString: string) {
    return this._http.get(this.baseUrl + '/api/Schedule/IsTemporaryScheduleWindowOpen/' + scheduleWindowAsString, { headers: this._reqHeader });
  }

  getScheduleWindowOpenStates() {
    return this._http.get<Record<string, boolean>>(
      this.baseUrl + '/api/Schedule/GetScheduleWindowOpenStates', { headers: this._reqHeader }
    );
  }

  setProcessPricingRulesToNow() {
    return this._http.get(this.baseUrl + '/api/Schedule/SetOnDemandScheduledEventToNow/ProcessPricingRules', { headers: this._reqHeader });
  }
}
